import React, { useEffect, useState, useRef, useContext } from 'react'
import { useReactToPrint } from 'react-to-print';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { Container } from '@mui/system';
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, tableCellClasses } from '@mui/material';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import { Bar } from 'react-chartjs-2';
import PrintIcon from '@mui/icons-material/Print';
import { ComponentToPrintAllShopReport } from './ComponentToPrintAllShopReport'
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LineChartShopwise = ({startDate, endDate}) => {
  const [ordersPS, setOrdersPS] = useState([])
  const [ordersSK, setOrdersSK] = useState([])
  const [ordersGS, setOrdersGS] = useState([])
  const [labels, setLabels] = useState();
  const [net, setNet] = useState();
  const [total, setTotal] = useState();
  const [cancel, setCancel] = useState();
  const [labels1, setLabels1] = useState();
  const [net1, setNet1] = useState();
  const [total1, setTotal1] = useState();
  const [cancel1, setCancel1] = useState();
  const [net2, setNet2] = useState();
  const [total2, setTotal2] = useState();
  const [cancel2, setCancel2] = useState();
  const [labels2, setLabels2] = useState();
  const [loading, setLoading] = useState(false)
  const { user, shop } = useContext(AuthContext);

  useEffect(() => {
    const loadData = async() => {
      try {
        setLoading(true)
        let d = new Date(endDate)
        d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        const res = await axios.post("/orders/dailysalesallshop", {startDate, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})        
        const label=[]
        const net=[]
        const total=[]
        const cancel=[]
        const sortedPSData = res.data.ordersPS.sort((a,b) => {return new Date(a._id).getTime() - new Date(b._id).getTime()});
        sortedPSData.map(item => {
          label.push(convertDate(item._id))
          total.push(item.without_cancel)
          cancel.push(item.with_cancel)
          return net.push(item.total)
        });
        setLabels(label);
        setNet(net);
        setTotal(total);
        setCancel(cancel);
        setOrdersPS(sortedPSData)

        const label1=[]
        const net1=[]
        const total1=[]
        const cancel1=[]
        const sortedSKData = res.data.ordersSK.sort((a,b) => {return new Date(a._id).getTime() - new Date(b._id).getTime()});
        sortedSKData.map(item => {
          label1.push(convertDate(item._id))
          total1.push(item.without_cancel)
          cancel1.push(item.with_cancel)
          return net1.push(item.total)
        });
        setLabels1(label1);
        setNet1(net1);
        setTotal1(total1);
        setCancel1(cancel1);
        setOrdersSK(sortedSKData)

        const label2=[]
        const net2=[]
        const total2=[]
        const cancel2=[]
        const sortedGSData = res.data.ordersGS.sort((a,b) => {return new Date(a._id).getTime() - new Date(b._id).getTime()});
        sortedGSData.map(item => {
          label2.push(convertDate(item._id))
          total2.push(item.without_cancel)
          cancel2.push(item.with_cancel)
          return net2.push(item.total)
        });
        setLabels2(label2);
        setNet2(net2);
        setTotal2(total2);
        setCancel2(cancel2);
        setOrdersGS(sortedGSData)
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop]);
  const convertDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" +  d.getFullYear();
  }
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: "Daily Sales Report - Park Shop(PS)",
      },
    },
  };
  const data = {
    labels,
    'datasets': [
      {
        label: "Total Sales",
        data: total,
        backgroundColor: '#118DFF',
      },
      {
        label: "Canceled Sales",
        data: cancel,
        backgroundColor: '#F28A90',
      },
      {
        label: "Net Sales",
        data: net,
        backgroundColor: '#009292',
      }
    ]
  };
  const options1 = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: "Daily Sales Report - Sokkar Kovil(SK)",
      },
    },
  };
  const data1 = {
    labels: labels1,
    'datasets': [
      {
        label: "Total Sales",
        data: total1,
        backgroundColor: '#118DFF',
      },
      {
        label: "Canceled Sales",
        data: cancel1,
        backgroundColor: '#F28A90',
      },
      {
        label: "Net Sales",
        data: net1,
        backgroundColor: '#009292',
      }
    ]
  };
  const options2 = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: "Daily Sales Report - Ganthi Silai(GS)",
      },
    },
  };
  const data2 = {
    labels: labels2,
    'datasets': [
      {
        label: "Total Sales",
        data: total2,
        backgroundColor: '#118DFF',
      },
      {
        label: "Canceled Sales",
        data: cancel2,
        backgroundColor: '#F28A90',
      },
      {
        label: "Net Sales",
        data: net2,
        backgroundColor: '#009292',
      }
    ]
  };
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#1776d1',
      color: 'white',
    }
  }));
  
  const componentRef= useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current
  })
  return (
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      <PrintIcon size="small" onClick={handleReactToPrint} color="success"></PrintIcon>
      <Grid container>
        <Grid container>
          <Grid item xs={6} sx={{ padding: 1}}>
            <Bar data={data} options={options}/>
          </Grid>
          <Grid item xs={6} sx={{padding: 1}}>
            {ordersPS && 
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan="8" align="center">Park Shop - PS</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Cash</StyledTableCell>
                    <StyledTableCell>Card</StyledTableCell>
                    <StyledTableCell>UPI</StyledTableCell>
                    <StyledTableCell>Total</StyledTableCell>
                    <StyledTableCell>Cancel</StyledTableCell>
                    <StyledTableCell>Net</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {ordersPS.map((item, index) => (
                  <TableRow key={item._id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>{convertDate(item._id)}</StyledTableCell>
                    <StyledTableCell>{item.cash}</StyledTableCell>
                    <StyledTableCell>{item.card}</StyledTableCell>
                    <StyledTableCell>{item.upi}</StyledTableCell>
                    <StyledTableCell>{item.total}</StyledTableCell>
                    <StyledTableCell>{item.with_cancel}</StyledTableCell>
                    <StyledTableCell>{item.without_cancel}</StyledTableCell>
                  </TableRow>
                ))}
                </TableBody>
              </Table>      
            </TableContainer>}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6} sx={{ padding: 1}}>
            <Bar data={data1} options={options1}/>
          </Grid>
          <Grid item xs={6} sx={{padding: 1}}>
            {ordersSK && 
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan="8" align="center">Sokkar Kovil - SK</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Cash</StyledTableCell>
                    <StyledTableCell>Card</StyledTableCell>
                    <StyledTableCell>UPI</StyledTableCell>
                    <StyledTableCell>Total</StyledTableCell>
                    <StyledTableCell>Cancel</StyledTableCell>
                    <StyledTableCell>Net</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {ordersSK.map((item, index) => (
                  <TableRow key={item._id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>{convertDate(item._id)}</StyledTableCell>
                    <StyledTableCell>{item.cash}</StyledTableCell>
                    <StyledTableCell>{item.card}</StyledTableCell>
                    <StyledTableCell>{item.upi}</StyledTableCell>
                    <StyledTableCell>{item.total}</StyledTableCell>
                    <StyledTableCell>{item.with_cancel}</StyledTableCell>
                    <StyledTableCell>{item.without_cancel}</StyledTableCell>
                  </TableRow>
                ))}
                </TableBody>
              </Table>      
            </TableContainer>}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6} sx={{ padding: 1}}>
            <Bar data={data2} options={options2}/>
          </Grid>
          <Grid item xs={6} sx={{padding: 1}}>
            {ordersGS && 
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan="8" align="center">Ganthi Silai - GS</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Cash</StyledTableCell>
                    <StyledTableCell>Card</StyledTableCell>
                    <StyledTableCell>UPI</StyledTableCell>
                    <StyledTableCell>Total</StyledTableCell>
                    <StyledTableCell>Cancel</StyledTableCell>
                    <StyledTableCell>Net</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {ordersGS.map((item, index) => (
                  <TableRow key={item._id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>{convertDate(item._id)}</StyledTableCell>
                    <StyledTableCell>{item.cash}</StyledTableCell>
                    <StyledTableCell>{item.card}</StyledTableCell>
                    <StyledTableCell>{item.upi}</StyledTableCell>
                    <StyledTableCell>{item.total}</StyledTableCell>
                    <StyledTableCell>{item.with_cancel}</StyledTableCell>
                    <StyledTableCell>{item.without_cancel}</StyledTableCell>
                  </TableRow>
                ))}
                </TableBody>
              </Table>      
            </TableContainer>}
          </Grid>
        </Grid>
      </Grid>
      <div style={{display: 'none'}}>
        { ordersPS && <ComponentToPrintAllShopReport ref={componentRef} title="Daily Sales Report - PS" data={ordersPS} title1="Daily Sales Report - SK" data1={ordersSK} title2="Daily Sales Report - GS" data2={ordersGS}  /> }
      </div>
    </Container>
  )
}

export default LineChartShopwise
